import { GridLayout, H4 } from '@deity/falcon-ui';
import type { CSSProperties, FC } from 'react';

type HeaderItemsType = {
  text: string;
  cssProps?: CSSProperties;
};

type THeadProps = {
  headerItems: HeaderItemsType[];
  gridTemplateColumns?: string;
  style?: CSSProperties;
};

export const Thead: FC<THeadProps> = ({ headerItems, gridTemplateColumns, style }) => (
  <GridLayout
    pl="xxl"
    pr="xxl"
    pb="sm"
    pt="sm"
    gridTemplateColumns={gridTemplateColumns}
    alignContent="center"
    alignItems="center"
    style={{ borderBottom: '1px solid #E0E2E5', ...style }}
  >
    {headerItems.map((h: HeaderItemsType) => (
      <H4
        key={h.text}
        color="secondary"
        fontSize="sm"
        fontWeight="bold"
        style={{ textTransform: 'uppercase', ...h.cssProps }}
      >
        {h.text}
      </H4>
    ))}
  </GridLayout>
);
